module.exports = __webpack_public_path__ + "static/timbo-africa_2-e5b68d3584a224702777828610629907.jpg";